import { createAction } from 'redux-actions';
import * as types from './types';

export const transactionsStart = createAction(types.TRANSACTIONS_START);
export const transactionsSuccess = createAction(types.TRANSACTIONS_SUCCESS);
export const transactionsError = createAction(types.TRANSACTIONS_ERROR);
export const transactionsMoreStart = createAction(types.TRANSACTIONS_MORE_START);
export const transactionsMoreSuccess = createAction(types.TRANSACTIONS_MORE_SUCCESS);
export const transactionsRefreshStart = createAction(types.TRANSACTIONS_REFRESH_START);
